import { PersonStatus_Enum } from '@weave/schema-gen-ts/dist/shared/persons/v3/enums.pb';
import dayjs from 'dayjs';
import { i18next } from '@frontend/i18n';

export type ContactDetails = {
  firstName: string;
  lastName: string;
  gender: string;
  age: number;
  birthdate?: string;
  status: PersonStatus_Enum;
  avatarUrl?: string;
};

export enum PracticeVertical {
  Dental = 'dental',
  MentalHealth = 'mental_health',
  Veterinary = 'veterinary',
  MedicalSpa = 'medical_spa',
  EyeCare = 'eye_care',
  Other = 'other',
}

export type PracticeVerticalOption = {
  id: PracticeVertical;
  name: string;
};

export const PRACTICE_VERTICALS: PracticeVerticalOption[] = [
  { id: PracticeVertical.Dental, name: i18next.t('Dental Practice', { ns: 'schedule-onboarding' }) },
  { id: PracticeVertical.MentalHealth, name: i18next.t('Mental Health / Therapy', { ns: 'schedule-onboarding' }) },
  { id: PracticeVertical.Veterinary, name: i18next.t('Veterinary Clinic', { ns: 'schedule-onboarding' }) },
  { id: PracticeVertical.MedicalSpa, name: i18next.t('Medical Spa / Aesthetics', { ns: 'schedule-onboarding' }) },
  { id: PracticeVertical.EyeCare, name: i18next.t('Eye Care / Optometry', { ns: 'schedule-onboarding' }) },
  { id: PracticeVertical.Other, name: i18next.t('Other Industry', { ns: 'schedule-onboarding' }) },
];

export const APPOINTMENT_TYPES_PRACTICE_VERTICAL_MAP: Record<PracticeVertical, string[]> = {
  [PracticeVertical.Dental]: [
    i18next.t('Cleaning & Exam', { ns: 'schedule-onboarding' }),
    i18next.t('New Patient Consultation', { ns: 'schedule-onboarding' }),
    i18next.t('Teeth Whitening', { ns: 'schedule-onboarding' }),
    i18next.t('Fillings', { ns: 'schedule-onboarding' }),
    i18next.t('Crowns & Bridges', { ns: 'schedule-onboarding' }),
  ],
  [PracticeVertical.MentalHealth]: [
    i18next.t('Individual Session', { ns: 'schedule-onboarding' }),
    i18next.t('Couples Session', { ns: 'schedule-onboarding' }),
    i18next.t('Initial Consultation', { ns: 'schedule-onboarding' }),
    i18next.t('Group Session', { ns: 'schedule-onboarding' }),
    i18next.t('Child & Adolescent Session', { ns: 'schedule-onboarding' }),
  ],
  [PracticeVertical.Veterinary]: [
    i18next.t('Wellness Exam', { ns: 'schedule-onboarding' }),
    i18next.t('Vaccination', { ns: 'schedule-onboarding' }),
    i18next.t('Spay/Neuter Surgery', { ns: 'schedule-onboarding' }),
    i18next.t('Dental Cleaning', { ns: 'schedule-onboarding' }),
    i18next.t('Sick Pet Visit', { ns: 'schedule-onboarding' }),
  ],
  [PracticeVertical.MedicalSpa]: [
    i18next.t('Botox / Neurotoxin Injections', { ns: 'schedule-onboarding' }),
    i18next.t('Dermal Fillers', { ns: 'schedule-onboarding' }),
    i18next.t('Laser Hair Removal', { ns: 'schedule-onboarding' }),
    i18next.t('Microneedling', { ns: 'schedule-onboarding' }),
    i18next.t('Chemical Peel', { ns: 'schedule-onboarding' }),
  ],
  [PracticeVertical.EyeCare]: [
    i18next.t('Comprehensive Exam', { ns: 'schedule-onboarding' }),
    i18next.t('Contact Lens Fitting', { ns: 'schedule-onboarding' }),
    i18next.t('Glasses Fitting', { ns: 'schedule-onboarding' }),
    i18next.t('Diabetic Eye Exam', { ns: 'schedule-onboarding' }),
    i18next.t('Dry Eye Evaluation', { ns: 'schedule-onboarding' }),
  ],
  [PracticeVertical.Other]: [
    i18next.t('New Client', { ns: 'schedule-onboarding' }),
    i18next.t('Follow-up Appointment', { ns: 'schedule-onboarding' }),
  ],
};

const createContact = (firstName: string, lastName: string, gender: string, age: number): ContactDetails => ({
  firstName,
  lastName,
  gender,
  age,
  avatarUrl: '',
  status: PersonStatus_Enum.ACTIVE,
  birthdate: dayjs().subtract(age, 'year').format('YYYY-MM-DD'),
});

export const DUMMY_CONTACT_DETAILS: Record<PracticeVertical, ContactDetails> = {
  [PracticeVertical.Dental]: createContact('Test', 'Miller', 'female', 33),
  [PracticeVertical.MentalHealth]: createContact('Demo', 'Wilson', 'male', 37),
  [PracticeVertical.Veterinary]: createContact('Mock', 'Taylor', 'male', 3),
  [PracticeVertical.MedicalSpa]: createContact('Demo', 'Thompson', 'female', 71),
  [PracticeVertical.EyeCare]: createContact('Sample', 'Chen', 'female', 37),
  [PracticeVertical.Other]: createContact('Sample', 'Taylor', 'male', 43),
};
